import React from 'react';

import agripixImageToPrompt from '../../assets/images/agripix-image-to-prompt.jpg';
import agripixImageOptions from '../../assets/images/agripix-image-options.jpg';
import agripixImageGeneration from '../../assets/images/agripix-image-generation.jpg';
import agripixIntroduction from '../../assets/images/agripix-introduction.jpg';
import agripixPromptGuidelines from '../../assets/images/agripix-prompt-guidelines.jpg';


const videoData = [
  {
    title: 'AgriPix Image to Prompt',
    imageSrc: agripixImageToPrompt,
    url: 'https://youtu.be/3X2nkZCMIL8',
  },
  {
    title: 'AgriPix Image Options',
    imageSrc: agripixImageOptions,
    url: 'https://youtu.be/xpY63_32pOY',
  },
  {
    title: 'AgriPix Image Generation',
    imageSrc: agripixImageGeneration,
    url: 'https://youtu.be/2fkuE0gjTyM',
  },
  {
    title: 'AgriPix Introduction',
    imageSrc: agripixIntroduction,
    url: 'https://youtu.be/4ph7YBg8ILo',
  },
  {
    title: 'AgriPix Prompt Guidelines',
    imageSrc: agripixPromptGuidelines,
    url: 'https://youtu.be/Gt6DWzayZrI',
  },
];

const VideoList = () => {
  return (
    <div className="quick-reads-grid">
      {videoData.map((video, index) => (
        <a
          key={index}
          href={video.url}
          target="_blank"
          rel="noopener noreferrer"
          className="image-card video-player"
        >
          <img src={video?.imageSrc} alt={video.title} />
          <div className='quick-reads-title'>{video.title}</div>
        </a>
      ))}
    </div>
  );
};

export default VideoList;
